var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_7df3a136"]},_vm.$listeners),[_c('cube-divider',{attrs:{"position":_vm.position,"text":"文本内容"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }